import { render, staticRenderFns } from "./DeviceAnnualInspection.vue?vue&type=template&id=66cd11a5&scoped=true"
import script from "./DeviceAnnualInspection.vue?vue&type=script&lang=js"
export * from "./DeviceAnnualInspection.vue?vue&type=script&lang=js"
import style0 from "./DeviceAnnualInspection.vue?vue&type=style&index=0&id=66cd11a5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd11a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66cd11a5')) {
      api.createRecord('66cd11a5', component.options)
    } else {
      api.reload('66cd11a5', component.options)
    }
    module.hot.accept("./DeviceAnnualInspection.vue?vue&type=template&id=66cd11a5&scoped=true", function () {
      api.rerender('66cd11a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeviceAnnualInspection/DeviceAnnualInspection.vue"
export default component.exports